import { Divider, Flex, Popover, Tooltip } from '@byecode/ui'
import type { GroupOption } from '@lighthouse/shared'
import { GroupList, TagIcon } from '@lighthouse/shared'
import cls from 'classnames'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'

import type { CreatePagePayload } from '@/atoms/page/types'

import { CreatePage } from '../CreatePage'
import { Search } from '../Search'
import * as CM from '../style'

export type FilterParams = {
    searchWord: string
    groupId: string
}
interface PageListHeaderProps {
    options: GroupOption[]
    value: FilterParams
    onChange?: (value: FilterParams) => void
    onAddPage: (v: CreatePagePayload) => void
}

const SCxIconTarget = styled.div`
    display: flex;
    align-items: center;
    &:hover {
        ${CM.Icon} {
            color: var(--color-black);
        }
    }

    &.active {
        ${CM.Icon} {
            color: var(--color-main);
        }
    }
`

const PageListHeader: React.FunctionComponent<PageListHeaderProps> = ({ options, value, onAddPage, onChange }) => {
    const { searchWord, groupId } = value
    const [opened, setOpened] = useState(false)

    const handleChange = useCallback(
        (item: GroupOption) => {
            onChange?.({ searchWord, groupId: item.value })
            setOpened(false)
        },
        [onChange, searchWord]
    )

    return (
        <CM.Header>
            <Flex gap={8}>
                <Search
                    value={searchWord}
                    clearable
                    suffix={
                        <Popover position="bottom-start" opened={opened} width={200} withinPortal onChange={setOpened}>
                            <Popover.Target>
                                <div>
                                    <Tooltip title="筛选" withArrow offset={2} placement="top">
                                        <CM.IconWrapper size={32}>
                                            <SCxIconTarget className={cls({ active: groupId !== 'all' })}>
                                                <CM.Icon type="Filter" size={16} isAction />
                                            </SCxIconTarget>
                                        </CM.IconWrapper>
                                    </Tooltip>
                                </div>
                            </Popover.Target>
                            <Popover.Dropdown style={{ width: 200 }}>
                                <GroupList value={groupId} options={options} maxHeight={600} onItem={handleChange} />
                            </Popover.Dropdown>
                        </Popover>
                    }
                    onChange={val => onChange?.({ groupId, searchWord: val })}
                />
                <CreatePage
                    targetComponent={
                        <TagIcon
                            icon="Add"
                            size={32}
                            iconSize={16}
                            radius={6}
                            enableHover
                            iconColor="var(--color-gray-400)"
                            background="var(--color-gray-100)"
                            hoverColor="var(--color-gray-900)"
                            hoverBackground="var(--color-gray-200)"
                            style={{ flexShrink: 0 }}
                        />
                    }
                    onAdd={onAddPage}
                />
            </Flex>
            <Divider style={{ margin: '8px 0 8px 0' }} />
        </CM.Header>
    )
}

export default PageListHeader
